import { useEffect, useState } from "react";
import { subscribeReportDialog, type ReportDialogOptions } from "@/lib/error-report";
import { ReportProblemDialog } from "./report-problem-dialog";

/** O único «Reportar ou sugerir» da app, montado uma vez e aberto por `openReportDialog`. */
export const ReportProblemHost = () => {
  const [options, setOptions] = useState<ReportDialogOptions | null>(null);
  useEffect(() => subscribeReportDialog(setOptions), []);
  return (
    <ReportProblemDialog
      open={options !== null}
      onOpenChange={(open) => !open && setOptions(null)}
      {...(options ?? {})}
    />
  );
};
